import React from 'react';
import { MessageCircle } from 'lucide-react';

const ChatWidget = () => {
  return (
    <div className="aa-chat">
      <button className="aa-chat-btn">
        <MessageCircle className="aa-icon-md" />
      </button>
    </div>
  );
};

export default ChatWidget;

